const BLOCK = 0;
const BOOLEAN_BLOCK = 1;
const C_BLOCK = 2;
const E_BLOCK = 3;
const REPORTER_BLOCK = 4;

export { BLOCK, BOOLEAN_BLOCK, C_BLOCK, E_BLOCK, REPORTER_BLOCK };
